$(function (ws) {
    ws.views.storeShippingAddress = ws.views.modal.extend({
        events: {
            'click .cancel-event': 'closeModal',
            'click button.address-suggestion, input[type="button"].address-suggestion': 'submitUserSelection'
        },

        /**
         * Initialize the component.
         */
        initialize: function () {
            ws.views.modal.prototype.initialize.call(this);
            this.$modalBody = this.$('.modal-body');
            this.orderId = $('.order-meta-data').data('order-number');
            this.eventAgg.on('storeAccountAddAddress', this.bindModel, this);
            this.$addAddressTemplate = $('#add-address-template');
            this.$showAddressTemplate = $('#show-address-template');
            this.template = _.template(this.$addAddressTemplate.html());
            this.$generalError = this.$('.generalError');
        },

        /**
         * This function will submit user selection based on entered address and suggestions.
         */
        submitUserSelection: function (e) {
            var prop = $(e.currentTarget).data('address');
            var addressType = prop.type === 'SHIPTO' ? 'shipping-section' : 'endUser-section';
            var account = new ws.models.userAccountDetails(prop);
            var addressSelectionPending = false;

            if (prop.type === 'SHIPTO') {
                addressType = 'shipping-section';
                $('.shippingAddressSection').addClass('hide');
                $('.success').html('Shippind Address has been updated').removeClass('hide');
            } else if (prop.type === 'ENDCUSTOMER') {
                addressType = 'endUser-section';
                $('.endUserAddressSection').addClass('hide');
                $('.success').html('End User Address has been updated').removeClass('hide');
            }

            if (!$('.shippingAddressSection').hasClass('hide') || !$('.endUserAddressSection').hasClass('hide')) {
                addressSelectionPending = true;
            }

            this.eventAgg.trigger('settingUpShippingAddressByMDM', account, undefined, addressType, addressSelectionPending);

            if (!addressSelectionPending) {
                this.closeModal();
            }
        },

        /**
         * This function will show the response got from add address API(checking)
         */
        bindModel: function (data, dataType) {
            var showTable = false;
            this.$modalBody.find('.placeHolder:first').replaceWith(this.template(data));
            var userEnteredAddress = '';
            var divReformatedAddress = this.$modalBody.find('#reformatedAddress:first');
            var divReformatedAddressMDM = this.$modalBody.find('#reformatedAddressMDM:first');
            var buttonReformatedAddress = this.$modalBody.find('#reformatedAddressButton:first');
            var suggestionsDesc = this.$modalBody.find('#suggestionsDesc');
            var reformattedDesc = this.$modalBody.find('#reformattedDesc:first');
            var addResultTag = this.$modalBody.find('.addResultTag');
            var $searchResults = this.$('#resultPage .comp-account-search-results');
            var $enduserSearchResults = this.$('#enduserResultPage .comp-account-search-results');
            var divEndUserReformatedAddress = this.$modalBody.find('#enduserReformatedAddress:first');

            var accountEntered;
            this.$generalError.html('');
            this.$generalError.hide();

            /**
             * This function return empty string for null
             */
            function getAddressVal(text) {
                if (text !== undefined && text !== null && text !== '') {
                    text = text + ', ';
                } else {
                    text = '';
                }

                return text;
            }

            /**
             * This function will set data for add address post.
             */
            function setAddressData (accountObj, accountType) {
                var addData = {
                    type: accountType,
                    sapId: getAddressVal(accountObj.get('sapId')),
                    name: getAddressVal(accountObj.get('accountName')),
                    address1: getAddressVal(accountObj.get('addressLine1')),
                    address2: getAddressVal(accountObj.get('addressLine2')),
                    address3: getAddressVal(accountObj.get('addressLine3')),
                    address4: getAddressVal(accountObj.get('addressLine4')),
                    locality: getAddressVal(accountObj.get('locality')),
                    state: getAddressVal(accountObj.get('state')),
                    zip: getAddressVal(accountObj.get('zipCode')),
                    country: accountObj.get('country').isocode
                };
                return addData;
            }

            /**
             * This function will set data properties.
             */
            function setDataProperties (dataAddress, buttonElementId, enteredAddDiv, _this) {
                if (dataAddress !== undefined && dataAddress !== null) {
                    accountEntered = new ws.models.userAccountDetails(dataAddress);
                    var addressType = buttonElementId === '#userEnteredAddressButton' ? 'Entered Address' : $('.reformattedAddress').val();
                    enteredAddDiv.html(_.template(_this.$showAddressTemplate.html())(setAddressData(accountEntered, addressType)));
                    var buttonElement = enteredAddDiv.find(buttonElementId);
                    userEnteredAddress =  accountEntered.toOneLine();
                    buttonElement.attr('data-address', JSON.stringify(accountEntered.toJSON()).replace(/'/g, '&#39;'));
                    buttonElement.attr('data-api', 'createaccount');
                    buttonElement.attr('data-updatetype', dataAddress.type);

                    //buttonUsereEnteredAddress.addClass('address-suggestion');
                }
            }

            /**
             * This function will set the data for suggested address table
             */
            function createSuggestedAddressTable(suggestedData, searchResults, tableId, id) {
                var buttonName = id === 'End-User' ? $('.selectEndUser').val() : $('.selectShipping').val();
                var templateData = {
                    rows: []
                };

                for (var i = 0; i < suggestedData.length; i++) {
                    var account = new ws.models.userAccountDetails(suggestedData[i]);
                    templateData.rows.push([
                        account.get('sapId'),
                        account.get('accountName'),
                        _.template('<span><@= address @></span>')({
                            address: account.toOneLine()
                        }),
                        '<button style="padding:0 3px !important;" class="button address-suggestion"  data-address-type="' + id + '" data-api="updateAccount" data-updatetype="' + account.get('type') + '" data-address=\'' + JSON.stringify(account.toJSON()).replace(/'/g, '&#39;') + '\' data-id= "' + account.get('sapId') + '" >' + buttonName + '</button>'
                    ]);
                    showTable = true;
                }

                searchResults.parent().addClass('search-results-width-set');

                var $dataTable = searchResults.find('.comp-data-table');
                var $dataTableBody = searchResults.find('.comp-data-table tbody');
                var dataTableTemplate = _.template(searchResults.find('script#search-results-table-body-template').html());
                $dataTableBody.html(dataTableTemplate(templateData));
                searchResults.find('.results').toggle(true);

                let table = tableId;
                if ($.fn.dataTable.isDataTable(table)) {
                    table.DataTable().destroy();
                }

                new ws.views.dataTable({el:$dataTable});
            }

            var dataSuggested = '';
            var dataReformatted = '';
            var dataEndUserSuggested = '';
            var dataEndUserReformatted = '';

            if (dataType === 'checkout') {
                dataSuggested = data.shippingAddress.suggested;
                dataReformatted = data.shippingAddress.reformatted;
                $('.shippingAddressSection').removeClass('hide');
                $('#mdmResultHeaderShipping').removeClass('hide');

                if (!data.sameAsShippingAddress) {
                    dataEndUserSuggested = data.endUserAddress.suggested;
                    dataEndUserReformatted = data.endUserAddress.reformatted;
                    $('.endUserAddressSection').removeClass('hide');
                    $('#mdmResultHeaderEnduser').removeClass('hide');
                }
            } else if (dataType === 'checkout-ship') {
                dataSuggested = data.suggested;
                dataReformatted = data.reformatted;
                $('.endUserAddressSection').addClass('hide');
                $('.shippingAddressSection').removeClass('hide');
                $('#mdmResultHeaderShipping').removeClass('hide');
                $('#mdmResultHeaderEnduser').addClass('hide');

            } else if (dataType === 'checkout-endUser') {
                dataEndUserSuggested = data.suggested;
                dataEndUserReformatted = data.reformatted;
                $('.shippingAddressSection').addClass('hide');
                $('.endUserAddressSection').removeClass('hide');
                $('#mdmResultHeaderEnduser').removeClass('hide');
                $('#mdmResultHeaderShipping').addClass('hide');

            } else {
                dataSuggested = data.suggested;
                dataReformatted = data.reformatted;
                $('.endUserAddressSection').addClass('hide');
                $('.shippingAddressSection').removeClass('hide');
                $('#mdmResultHeaderShipping').addClass('hide');
                $('#mdmResultHeaderEnduser').addClass('hide');
            }

            if (dataSuggested && dataSuggested.length) {
                reformattedDesc.addClass('hide');
                suggestionsDesc.removeClass('hide');
                buttonReformatedAddress.addClass('address-suggestion');
                buttonReformatedAddress.removeClass('hide');
                divReformatedAddressMDM.removeClass('hide');

                setDataProperties(dataReformatted, '#reformatedAddressButton', divReformatedAddressMDM, this);
                divReformatedAddressMDM.removeClass('suggested-address');

                createSuggestedAddressTable(dataSuggested, $searchResults, this.$('table'), 'Shipping');
            } else if (dataReformatted) {
                reformattedDesc.removeClass('hide');
                buttonReformatedAddress.addClass('address-suggestion');
                buttonReformatedAddress.removeClass('hide');
                divReformatedAddressMDM.removeClass('hide');
                setDataProperties(dataReformatted, '#reformatedAddressButton', divReformatedAddressMDM, this);
                divReformatedAddressMDM.removeClass('suggested-address');
                $('.mdmResultHeader').addClass('hide');
            }

            if (!data.sameAsShippingAddress && dataEndUserSuggested && dataEndUserSuggested.length) {
                divEndUserReformatedAddress.removeClass('hide');
                reformattedDesc.addClass('hide');
                suggestionsDesc.removeClass('hide');

                setDataProperties(dataEndUserReformatted, '#reformatedAddressButton', divEndUserReformatedAddress, this);
                divEndUserReformatedAddress.removeClass('suggested-address');

                // $('.endUserAndShipping').css('padding-top', '3% !important');
                createSuggestedAddressTable(dataEndUserSuggested, $enduserSearchResults, this.$('#enduserResultPage table'), 'End-User');
            }

            this.onOpen();
        }
    });
}(westcon));
